import { PaginationControls } from '@webapp/core/components/PaginationControls'
import { type LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'
import { LegalEntityListView } from '@webapp/platform/legal-entities/features/list-legal-entities/views/LegalEntityListView'
import {
  LEGAL_ENTITY_LIST_PAGINATION_ID,
  useLegalEntityListPresenter,
} from './useLegalEntityListPresenter'

export interface ILegalEntityListPresenterProps {
  isActive: boolean
  onAdd: () => void
  onEdit: (entity: LegalEntity) => void
  onSelect: (entity: LegalEntity) => void
  onDeactivate: (entity: LegalEntity) => void
  onActivate: (entity: LegalEntity) => void
}

export const LegalEntityListPresenter = ({
  isActive,
  onAdd,
  onEdit,
  onSelect,
  onDeactivate,
  onActivate,
}: ILegalEntityListPresenterProps) => {
  const {
    data: { entities, totalCount, tabCount, hasSearch, isFirstRunEmpty },
    states: { isLoading, hasLoadFailed },
  } = useLegalEntityListPresenter({ isActive })

  return (
    <PaginationControls id={LEGAL_ENTITY_LIST_PAGINATION_ID}>
      <LegalEntityListView
        entities={entities}
        totalCount={totalCount}
        tabCount={tabCount}
        hasSearch={hasSearch}
        isFirstRunEmpty={isFirstRunEmpty}
        hasLoadFailed={hasLoadFailed}
        isActive={isActive}
        isLoading={isLoading}
        onAdd={onAdd}
        onEdit={onEdit}
        onSelect={onSelect}
        onDeactivate={onDeactivate}
        onActivate={onActivate}
      />
    </PaginationControls>
  )
}

LegalEntityListPresenter.displayName = 'LegalEntityListPresenter'
